import React from "react";
import ScreenshotPic from "../../../../assets/images/screenshot.png";
// import BlockWebCategory from "../../../../assets/images/block-website-category.png";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";

export default function ManualScreenshotModal({
  showModal,
  closeModal,
  errorMessage,
  getLangTranslation,
}) {
  const history = useHistory();

  const handlePage = () => {
    history.push({
      // pathname: '/manual-screenshots',
      pathname: "/screenshots",
      state: { previousPage: "MANUAL" },
    });
  };
  return (
    <Modal show={showModal} size="sm" className="custom-modal blur-bg" centered>
      <Modal.Header>
        <div className="border-0 pb-0 d-flex justify-content-between w-100">
          <h6 className="modal-title text-blue-900">
            {getLangTranslation("CHILD_DETAIL_SCREENSHOT", "Manual screenshot")}
          </h6>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
      </Modal.Header>
      <Modal.Body className="py-1 px-4">
        <div className="modal-body">
          <img className="d-block mx-auto mb-6" alt="" src={ScreenshotPic} />
          <h6
            className={`my-6 text-center ${
              errorMessage ? "text-danger" : "text-blue-900"
            }`}
          >
            {errorMessage
              ? getLangTranslation(
                  errorMessage,
                  "Please Enable Screenshot Permission"
                )
              : getLangTranslation(
                  "SCREENSHOT_HAS_TAKEN_YOU_CAN_SEE_FULL_DETAIL_TEXT",
                  "A screenshot has been taken, you can see the full details on the screenshot page"
                )}
          </h6>
          {errorMessage ? (
            <button
              className="btn btn-primary w-100"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            >
              <span className="text-capitalize fs-6" onClick={closeModal}>
                {getLangTranslation("GO_BACK", "Go Back")}
              </span>
            </button>
          ) : (
            <button
              className="btn btn-primary w-100"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handlePage}
            >
              <span className="btn-upper-case">
                {getLangTranslation(
                  "SCREENSHOT_PAGE_DEVICE_BUTTON",
                  "VIEW NOW"
                )}
              </span>
            </button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
